






import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'PreviewController'
})
export default class PreviewController extends Vue {
  @Prop({ default: true, type: Boolean }) showLeft: boolean
  @Prop({ default: true, type: Boolean }) showRight: boolean

  handleControlPage(go: number) {
    this.$emit('control', go)
  }
}
